<template lang="pug">
.banner1.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(
  :style="`min-height: calc(100vh - ${$vuetify.application.top}px)`"
)
  v-container(fluid)
    v-row
      v-col
        v-row(justify="center" align="center")
          v-col.text-md-center(cols="auto")
            h2.mb-4.mb-sm-8.ibm.text-h3.text-md-h2.white--text Suas aulas totalmente digitais!
        v-row(justify="center" align="center")
          v-col.text-md-center(cols="auto")
            .mb-4.mb-sm-14.text-body-1.text-md-h6.font-weight-regular.heebo.grey--text.text--lighten-4(
              style="max-width: 656px"
            ) O Erudio oferece os recursos para você criar sua própria página de vendas de cursos online. Explore seu potencial digital e faça suas vendas crescerem cada vez mais!
        v-row(justify="center" align="center")
          v-col.text-sm-center
            v-btn.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
              color="accent"
              depressed
              :block="$vuetify.breakpoint.xsOnly"
              height=56
              @click="$router.push('/contato')"
            ) Quero vender cursos online
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="sass" scoped></style>
